import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TeacherClassSubjectService {
  constructor(private httpClient: HttpClient) {}

  createTeacherClassSubject(url: string, subjectForm: any): Observable<any> {
    return this.httpClient.post<any>(url, subjectForm, {
      headers: { accept: '*/*' },
    }) as Observable<any>;
  }
}
